import { useMemo, useState } from 'preact/hooks';
import { DAYS } from '../lib/calendar.ts';
import { addDays, frDayDate, parseLocalDate } from '../lib/dates.ts';
import { SUBJECTS } from '../lib/subjects.ts';
import { live, useStore } from '../store/store.ts';

/** A subject-by-subject table of contents for the teacher's paper binders. */
export function LessonsPage() {
  const lessons = live(useStore((s) => s.lessons));
  const [query, setQuery] = useState('');
  const needle = query.trim().toLocaleLowerCase('fr');

  const grouped = useMemo(() => {
    const visible = lessons
      .filter((lesson) =>
        !needle || [lesson.lessonNumber, lesson.title, lesson.subject, lesson.domain]
          .some((value) => value.toLocaleLowerCase('fr').includes(needle)),
      )
      .sort((a, b) =>
        a.weekStart.localeCompare(b.weekStart) || a.day - b.day || a.slot - b.slot,
      );

    return SUBJECTS.map(([subject]) => ({
      subject,
      lessons: visible.filter((lesson) => lesson.subject === subject),
    })).filter((group) => group.lessons.length > 0);
  }, [lessons, needle]);

  return (
    <section class="page printLessonList">
      <div class="sectionTitle">
        <div>
          <h1>Liste des leçons</h1>
          <p class="muted">Table des matières par matière pour retrouver rapidement tes leçons dans tes fardes.</p>
        </div>
        <button class="btn" onClick={() => window.print()}>Imprimer</button>
      </div>

      <div class="card lessonListSearch">
        <label for="lesson-search">Rechercher une leçon ou une référence</label>
        <input
          id="lesson-search"
          type="search"
          value={query}
          placeholder="Ex. FR-12, numération…"
          onInput={(event) => setQuery(event.currentTarget.value)}
        />
      </div>

      {grouped.length === 0 ? (
        <p class="empty">{needle ? 'Aucune leçon ne correspond à cette recherche.' : 'Aucune leçon enregistrée.'}</p>
      ) : grouped.map(({ subject, lessons: subjectLessons }) => (
        <section class="lessonListGroup" key={subject}>
          <h2>{subject} <span class="muted small">({subjectLessons.length})</span></h2>
          <div class="card lessonTableScroll">
            <table class="lessonTable">
              <thead><tr><th>Référence</th><th>Leçon</th><th>Domaine</th><th>Date</th></tr></thead>
              <tbody>
                {subjectLessons.map((lesson) => {
                  const date = addDays(parseLocalDate(lesson.weekStart), lesson.day);
                  return (
                    <tr key={lesson.id}>
                      <td><strong>{lesson.lessonNumber || '—'}</strong></td>
                      <td>{lesson.title}</td>
                      <td>{lesson.domain || '—'}</td>
                      <td>{DAYS[lesson.day]} {frDayDate(date)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </section>
      ))}
    </section>
  );
}
